import Service, { getCallApiFunction } from '../service'

interface IReadNotificationParams {
  notificationIds: string[]
}

class ReadNotificationApi extends Service {
  constructor(params: IReadNotificationParams) {
    super()
    this.name = 'READ_NOTIFICATION'

    this.config = {
      url: `/v1/notification/reads`,
      method: 'POST',
      data: params,
    }
  }
}

export const readNotification = (params: IReadNotificationParams) => getCallApiFunction(new ReadNotificationApi(params))
